// Búsqueda de ficheros de idiomas debe ser literal
// Esto va a localizar todos los ficheros json y despues en el bucle de ficheros se van a filtrar
// los adecuados
const appContext = require.context('locales', true, /^\.\/.*\.json$/)
const coreContext = require.context('core/locales', true, /^\.\/.*\.json$/)

export default [coreContext, appContext]
